module.exports = __webpack_public_path__ + "img/404.64db1264.jpg";